import gql from 'graphql-tag'

export const SIGN_IN_MUTATION = gql`
mutation SignInMutation(
  $username: String!, $password: String!, $expoPushToken: String
) {
  signIn(username: $username, password: $password, expoPushToken: $expoPushToken) {
    isFirstLogin
    authToken
    user {
     userType
    }
  }
}
`





// WEBPACK FOOTER //
// ./src/mutations/SIGN_IN_MUTATION.ts